import { render, staticRenderFns } from "./EditShapesImportFromFile.vue?vue&type=template&id=1194b1e5&scoped=true&"
import script from "./EditShapesImportFromFile.vue?vue&type=script&lang=ts&"
export * from "./EditShapesImportFromFile.vue?vue&type=script&lang=ts&"
import style0 from "./EditShapesImportFromFile.vue?vue&type=style&index=0&id=1194b1e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194b1e5",
  null
  
)

export default component.exports